import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { BadgeDollarSign, Clock3, HeartHandshake } from "lucide-react";

const PILLARS = [
  {
    icon: BadgeDollarSign, title: "Transparent pricing",
    text: "The price you see is the price you pay, VAT included, with the deposit disclosed before checkout. No airport surprises, no fine print fees, and no 'from' prices that double at the counter.",
    points: ["Every charge itemized before payment", "Deposit or No-Deposit Waiver — your choice", "Toll and fine admin fees published upfront"],
  },
  {
    icon: Clock3, title: "Ready when we say",
    text: "Three hours after booking, your car is at the branch. Book delivery and we arrive inside your chosen 30-minute slot. Land late? We track your flight and wait — at no extra charge.",
    points: ["3-hour branch readiness, guaranteed", "30-minute delivery slots, 09:00–21:00", "Flight tracking on every airport pickup"],
  },
  {
    icon: HeartHandshake, title: "People who answer",
    text: "A breakdown at 3am gets a human, not a phone tree. Complaints get a named response within 2 business days. And if something's our fault, we say so — then fix it.",
    points: ["24/7 roadside assistance, UAE-wide", "2-business-day complaint response", "Replacement vehicle after accident validation"],
  },
];

export default function Promise() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <div className="bg-[#144733]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 promo-stripe">
          <h1 className="heading-upper text-2xl sm:text-3xl text-white" data-testid="promise-heading">{t("The Europcar promise")}</h1>
          <p className="text-white/80 text-sm mt-2 max-w-xl">{t("Three commitments, kept on every rental. Written plainly, because that's the point.")}</p>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-12 w-full flex-1">
        <div className="grid md:grid-cols-3 gap-6" data-testid="promise-pillars">
          {PILLARS.map((p) => (
            <div key={p.title} className="bg-white rounded-2xl border border-[#E2E8F0] p-7 card-lift">
              <p.icon className="w-8 h-8 text-[#009900] mb-4" />
              <h2 className="heading-upper text-lg text-[#144733] mb-3">{t(p.title)}</h2>
              <p className="text-sm text-[#57685e] leading-relaxed">{t(p.text)}</p>
              <ul className="mt-4 space-y-2">
                {p.points.map((pt) => (
                  <li key={pt} className="text-xs text-[#0F1E17] pl-3 border-l-2 border-[#FFDC00]">{t(pt)}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link to="/#book" className="btn-cta rounded px-8 py-3.5 text-sm inline-block" data-testid="promise-book-cta">{t("Hold us to it — book a car")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
